module.exports = function() {
    // Alert when clicking btn-danger confirming if you really want to do that
    $(function() {
        $(document).ready(function(){
            $('.js-colorpicker').colorpicker({
            });
        });
    });
}();
